const asset_store = {
  state: {
    editingItem: true,
    editingInventory: true,
    editingUnit: false,
    focus: false,
    show_create_item: false,
    show_product_variations: false,
    show_create_inventory: false,
    show_new_inventory_form: false,
    show_create_unit: false,
    show_custom_svg: false,
    set_rte_focus: false,
    inventoryType: null,
    inventoryRecord: null,
    newCrossRef: false,
    showLinkToSimilar: false,
    shelfLife: 0,
    shelfLifeType: 5,
    currentShelfLifeType: 5,
    crossRefDefaultValue: null,
    campaign_id: null,
    activeViewType: 'table'
  },

  getters: {
    editingItem: (state) => state.editingItem,
    editingInventory: (state) => state.editingInventory,
    editingUnit: (state) => state.editingUnit,
    show_create_inventory: (state) => state.show_create_inventory,
    show_new_inventory_form: (state) => state.show_new_inventory_form,
    focus: (state) => state.focus,
    set_rte_focus: (state) => state.set_rte_focus,
    show_create_item: (state) => state.show_create_item,
    show_product_variations: (state) => state.show_product_variations,
    show_create_unit: (state) => state.show_create_unit,
    show_custom_svg: (state) => state.show_custom_svg,
    inventoryType: (state) => state.inventoryType,
    inventoryRecord: (state) => state.inventoryRecord,
    newCrossRef: (state) => state.newCrossRef,
    showLinkToSimilar: (state) => state.showLinkToSimilar,
    shelfLifeType: (state) => state.shelfLifeType,
    shelfLife: (state) => state.shelfLife,
    currentShelfLifeType: (state) => state.currentShelfLifeType,
    crossRefDefaultValue: (state) => state.crossRefDefaultValue,
    campaign_id: (state) => state.campaign_id,
    activeViewType: (state) => state.activeViewType
  },
  actions: {
  },
  mutations: {
    setEditingItem: (state, payload) => (state.editingItem = payload),
    setEditingInventory: (state, payload) => (state.editingInventory = payload),
    setEditingUnit: (state, payload) => (state.editingUnit = payload),
    set_show_create_inventory: (state, payload) => (state.show_create_inventory = payload),
    set_show_new_inventory_form: (state, payload) => (state.show_new_inventory_form = payload),
    set_focus:  (state, payload) => (state.focus = payload),
    set_set_rte_focus:  (state, payload) => (state.set_rte_focus = payload),
    set_show_create_item:  (state, payload) => (state.show_create_item = payload),
    set_show_product_variations:  (state, payload) => (state.show_product_variations = payload),
    set_show_create_unit:  (state, payload) => (state.show_create_unit = payload),
    set_show_custom_svg:  (state, payload) => (state.show_custom_svg = payload),
    setInventoryType:  (state, payload) => (state.inventoryType = payload),
    setInventoryRecord:  (state, payload) => (state.inventoryRecord = payload),
    setNewCrossRef:  (state, payload) => (state.newCrossRef = payload),
    setShowLinkToSimilar:  (state, payload) => (state.showLinkToSimilar = payload),
    setShelfLifeType:  (state, payload) => (state.shelfLifeType = payload),
    setShelfLife:  (state, payload) => (state.shelfLife = payload),
    setCurrentShelfLifeType:  (state, payload) => (state.currentShelfLifeType = payload),
    setCrossRefDefaultValue:  (state, payload) => (state.crossRefDefaultValue = payload),
    setCampaign_id:  (state, payload) => (state.campaign_id = payload),
    setActiveViewType:  (state, payload) => (state.activeViewType = payload)
  }
}

export default asset_store;
